import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { makeStyles, withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormLabel from '@material-ui/core/FormLabel';
import { capitalize } from '@material-ui/core';
import CheckListOption from './CheckListOption';

const styles = () => ({
  root: {},
});


const MUI_COLORS = [
  'primary',
  'secondary',
  'default',
];

export const COLORS = [
  ...MUI_COLORS,
  'white',
];

const getColorProp = (color) => {
  if (COLORS.includes(color)) {
    return color;
  }
  return 'default';
};

const getRootColor = (color) => {
  return {
    color,
  };
};

const getCheckboxOptionColor = (color) => {
  return {
    color,
  };
};

const useCustomStyles = makeStyles(theme => ({
  rootColorPrimary: {},
  rootColorSecondary: {},
  rootColorWhite: getRootColor(theme.palette.common.white),
  checkboxOptionPrimary: {},
  checkboxOptionColorSecondary: {},
  checkboxOptionColorWhite: getCheckboxOptionColor(theme.palette.common.white),
}));

const CheckList = ({
  className,
  classes,
  label,
  options,
  onChange,
  value,
  color,
}) => {
  const {
    root: rootClass,
    ...restClasses
  } = classes;

  const customClasses = useCustomStyles();

  return (
    <FormControl
      className={classNames(classes.root, className)}
      component="fieldset"
    >
      {label && <FormLabel component="legend">{label}</FormLabel>}
      <FormGroup
        className={className}
        classes={{
          ...restClasses,
          root: classNames(rootClass, className, customClasses[`rootColor${capitalize(color)}`]),
        }}
      >
        {options.map((option) => {
          return (
            <CheckListOption
              key={option.value}
              className={classNames(customClasses[`checkboxOptionColor${capitalize(color)}`])}
              label={option.prompt}
              onChange={(evt) => {
                const isChecked = evt.target.checked;

                const withoutThisValue = value.filter(v => v !== option.value);

                const values = (isChecked) ? [...withoutThisValue, option.value] : withoutThisValue;

                return onChange(values);
              }}
              value={option.value}
              color={getColorProp(color)}
              isChecked={value.includes(option.value)}
            />
          );
        })}
      </FormGroup>
    </FormControl>
  );
};

CheckList.defaultProps = {
  className: '',
  label: null,
  color: 'inherit',
};

CheckList.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  label: PropTypes.string,
  options: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  color: PropTypes.oneOf(COLORS),
  value: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default withStyles(styles)(CheckList);
